import React, {useEffect, useState} from 'react'

const Privacy = () => {
    const [description, setDescription] = useState('')

    useEffect(() => {
        async function fetchData () {
            await fetch('https://s3-sa-east-1.amazonaws.com/vivosaludjproduction/privacy_new.json')
            .then(res => res.json())
            .then(res => {
                setDescription(res.content)
            })
        }

        fetchData()
    });

    return (
        <>
            <div style={{width: '100%', height: '100%', backgroundColor: 'white', padding: 40, fontSize: 16}}>
                <h1>Politicas de Privacidad</h1>
                <div dangerouslySetInnerHTML={{__html: description}}>
                </div>
            </div>
        </>
    )
}

export default Privacy